import { render, staticRenderFns } from "./ConfigurableTable.vue?vue&type=template&id=61803eea&scoped=true"
import script from "./ConfigurableTable.vue?vue&type=script&lang=js"
export * from "./ConfigurableTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61803eea",
  null
  
)

export default component.exports